import {
  faArrowRight,
  faCheck,
  faPrint,
  faTimes
} from "@fortawesome/pro-regular-svg-icons";

import { T } from "@repo/transifex";
import { Button } from "~/components";
import { usePrinterStatus } from "~/providers/app";

import { CardPaymentDialog } from "./card-payment-dialog";

type VerifySignatureProps = {
  onAcceptSignature: () => void;
  onRejectSignature: () => void;
  onPrintReceipt: () => void;
};

export const VerifySignature = ({
  onAcceptSignature,
  onRejectSignature,
  onPrintReceipt
}: VerifySignatureProps) => {
  const printerStatus = usePrinterStatus();

  const isPrinterReady = printerStatus === "success";
  const isPrinterLoading = printerStatus === "loading";

  return (
    <CardPaymentDialog
      title={<T _str="Signature Verification" />}
      description={<T _str="Please verify the signature on the receipt" />}
    >
      <div className="flex w-full flex-col justify-between gap-2">
        <Button
          variant="secondary"
          icon={faPrint}
          onClick={onPrintReceipt}
          disabled={isPrinterLoading}
          loading={isPrinterLoading}
        >
          <T _str="Print receipt" />
        </Button>

        <div className="flex w-full justify-between gap-2">
          <Button
            variant="danger"
            icon={faTimes}
            className="w-full"
            disabled={!isPrinterReady}
            onClick={onRejectSignature}
          >
            <T _str="Reject" />
          </Button>
          <Button
            variant="primary"
            icon={faCheck}
            className="w-full"
            disabled={!isPrinterReady}
            onClick={onAcceptSignature}
          >
            <T _str="Accept" />
          </Button>
        </div>

        <Button
          variant="transparent"
          className="w-full"
          icon={faArrowRight}
          onClick={onAcceptSignature}
        >
          <T _str="Skip" />
        </Button>
      </div>
    </CardPaymentDialog>
  );
};
